<template lang="pug">
md-layout.card
  md-dialog(:md-click-outside-to-close='false', :ref='dialogRef')
    md-dialog-title Preferences
    pre.dialog-content {{ dialogContent }}
    md-dialog-actions
      md-button(class='md-button md-raised md-primary handPointer md-theme-blue', @click='closeDialog()') Close

  md-table-card.table-card
    form.search-form(novalidate, @submit.stop.prevent='resetPaginationAndSearch')
      md-layout(:md-gutter='24', md-flex='100')
        md-layout(md-flex='30')
          md-input-container
            label User Name or ID
            md-input(v-model='filters.target')
        md-layout(md-flex='20')
          date-input(v-model='filters.startDate', :validation='$v.filters.startDate', :formSubmitted='true', label="From date")
        md-layout(md-flex='20')
          date-input(v-model='filters.endDate', :validation='$v.filters.endDate', :formSubmitted='true', label="To date")
        md-layout
          md-layout(md-flex='20', v-if='filters.target || filters.startDate || filters.endDate != ""')
            md-button.clean-search-label-btn.md-icon-button.btn(@click='cleanFilters')
              md-icon.icon(md-iconset="fa fa-trash-alt")
          md-layout(md-flex='25', md-align-small='center')
            md-button.search-btn.md-raised.md-icon-button.btn(type='submit', :disabled='loading || $v.$invalid')
              md-icon.icon(md-iconset="fa fa-search")

    stitch-loader(v-if='loading', :loading='loading', :size='45')
    div(v-if='hasLogsToDisplay')
      div.titleLine.styleRow
        p.rowElements Email
        p.rowElements Entity Name
        p.rowElements Action
        p.rowElements Action performed at
        p.rowElements 
      div.styleRow.colorHover(v-for='log in logs', :key='log._id')
        div.rowElements {{ log.userEmail }}
        div.rowElements {{ log.actionValue.name }}
        div.rowElements {{ log.action }}
        div.rowElements {{ moment(log.dateCreated) }}
        div.rowElements
          md-button.md-icon-button.md-raised.btn(@click='viewDetail(log.actionValue)')
            md-icon.icon(md-iconset="fa fa fa-eye")

    md-table-pagination(
      :md-size='currentPagination.size',
      :md-total='totalLogs',
      :md-page='currentPagination.page',
      md-label='Logs',
      md-separator='of',
      :md-page-options='[10, 25, 50, 100]',
      @pagination='onPageChanged'
    )
    div#no-results(v-if='hasNoResults')
      md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
      | No items to show
</template>

<script>
import uuid from 'uuid';
import moment from 'moment';
import { validationMixin } from 'vuelidate';
import { isValidDate } from '../../services/validatorService';
import userLogsService from '../../services/userLogsService';
import stitchLoader from '../../shared-components/Loader';
import DateInput from '../../shared-components/forms/DateInput';

export default {
  mixins: [validationMixin],
  components: {
    stitchLoader,
    DateInput
  },
  data() {
    return {
      logs: [],
      totalLogs: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10
      },
      sort: {
        name: 'dateCreated',
        type: 'desc'
      },
      filters: {
        target: '',
        startDate: '',
        endDate: ''
      },
      searchText: '',
      dialogContent: '',
      dialogRef: uuid.v4()
    };
  },
  validations: {
    filters: {
      startDate: {
        isValidDate(value) {
          return isValidDate(value);
        }
      },
      endDate: {
        isValidDate(value) {
          return isValidDate(value);
        }
      }
    }
  },
  computed: {
    searchParams() {
      const params = {
        offset: (this.searchText || this.currentPagination.page == 1) ? 0 : this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.$session.get("limitPaginationLogActivity") || this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type
      };
      const { startDate, endDate, target } = this.filters;
      if (startDate) {
        Object.assign(params, { startDate });
      }
      if (endDate) {
        Object.assign(params, { endDate });
      }
      if (target) {
        Object.assign(params, { target });
      }
      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalDistributions != null && params.offset >= this.totalDistributions) {
        params.offset = 0
      }

      return params;
    },
    hasLogsToDisplay() {
      return !this.loading && this.logs.length > 0;
    },
    hasNoResults() {
      return !this.loading && this.logs.length === 0;
    }
  },
  methods: {
    resetPaginationAndSearch() {
      this.currentPagination.page = 1;
      this.search();
    },
    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPageUserActivity", paginationParams.page);
      this.$session.set("limitPaginationLogActivity", paginationParams.size);
      this.search();
    },
    onSort(sortParams) {
      this.sort = sortParams;
      this.search();
    },

    search() {
      this.loading = true;
      userLogsService.getList(this.searchParams)
        .then((response) => {
          this.logs = response.data.activity;
          this.totalLogs = response.data.total;
        })
        .catch((error) => {
          console.error('Error while retrieving the list of logs', error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    closeDialog() {
      this.$refs[this.dialogRef].close();
    },
    viewDetail(value) {
      this.dialogContent = value;
      this.$refs[this.dialogRef].open();
    },
    moment: function (date) {
      return moment(date).format('MM-DD-YYYY HH:mm:ss');
    },

    cleanFilters() {
      this.filters.target = '';
      this.filters.startDate = '';
      this.filters.endDate = '';
    }
  },
  mounted() {
    if (this.$session.get("iWasInPageUserActivity") === undefined) {
      this.$session.set("iWasInPageUserActivity", 1);
    }
    this.currentPagination.page = this.$session.get('iWasInPageUserActivity');
    if (this.$session.get("limitPaginationLogActivity") !== undefined) {
      this.currentPagination.size = this.$session.get("limitPaginationLogActivity");
    }
    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageVideoSources", 1);
    this.search();
  },
  watch: {
    currentPagination(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPagination.page = 1
        this.search()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2) !important;
}

.filters {
  padding: 2px 20px;
}

.search-btn {
  margin-left: 3em;
}


.table-card {
  width: 100%;
  padding: 15px;
  border-radius: 10px;


}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

.dialog-content {
  margin: 15px;
  overflow: auto;
}

#no-results {
  margin: auto;
  padding: 20px;

  .md-icon {
    margin-right: 5px;
  }
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.colorHover:hover {
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}
</style>



// WEBPACK FOOTER //
// src/shared-components/userActivity/activityTable.vue